// Component for menu items in flight side-menu
import React from 'react';
import moment from 'moment';

import { getMelAmount } from '../utilities/helperfunctions';
import { timeConvert } from '../utilities/helperfunctions';
import './../style/slide-menu-items.scss';

export function FlightMenutItem(props) {
  function handleFlightClick(id) {
    props.changeFlight(id);
    props.toggleSlideOut();
  }

  const depatureDate = props.flight?.departureDateTime || new Date();
  const arrivalDate = props.flight?.arrivalDateTime || new Date();
  const flightTime =
    props.flight?.dbEstFlightTime?.[0] && props.flight?.dbEstFlightTime?.[0] > 0
      ? timeConvert(props.flight.dbEstFlightTime[0])
      : 'N/A';

  const melAmount = getMelAmount(props.flight?.sABC_MEL?.[0] || '');

  const isFlown = (() => {
    const arrival = props.flight?.arrivalDateTime;
    if (!arrival) return false;
    return moment(arrival).utc().isBefore(moment.utc());
  })();

  return (
    <div
      key={props.flightKey}
      className={`flight-menu-item ${isFlown && !props.isSelected ? 'flight-menu-item--toned' : ''} ${props.isSelected ? 'flight-menu-item--selected' : ''}`}
      onClick={() => handleFlightClick(props.flight?.id || '')}
    >
      <div className='space-between'>
        <p className='text-bold'>{props.flight?.sFltNo?.[0] || 'N/A'}</p>
        <div style={{ display: 'flex' }}>
          <p className='text-bold'>{props.flight?.sACReg?.[0] || 'N/A'}</p>
          <p className='text-red' style={{ marginLeft: '8px' }}>
            ({melAmount} {melAmount === 1 ? 'ATL' : 'ATLs'})
          </p>
        </div>
      </div>
      <div className='space-between'>
        <p className='text-red text-bold'>
          {moment(depatureDate).utc().format('HH:mm')}
        </p>
        {props.isCabinCrew ? (
          <p className='text-bold'>
            {props.flight?.sDep?.[0] || ''} - {props.flight?.sDest?.[0] || ''}
          </p>
        ) : (
          <p className='text-bold'>
            {props.flight?.sDepICAO?.[0] || ''} -{' '}
            {props.flight?.sDestICAO?.[0] || ''}
          </p>
        )}
        <p className='text-red text-bold'>
          {moment(arrivalDate).utc().format('HH:mm')}
        </p>
      </div>
      <div className='space-between'>
        <p>
          Flighttime <span className='text-red text-bold'>{flightTime}</span>
        </p>
          <p>
            Pax{' '}
            <span className='text-bold'>
              {props.flight?.nPax?.[0] === '-1'
                ? 'N/A'
                : props.flight?.nPax?.[0] || 'N/A'}
            </span>
          </p>
      </div>
    </div>
  );
}
